module.exports = __webpack_public_path__ + "static/assets/29373c99c85669bad8728a143a715b28.svg";